export let discountUnitLabel = function (discount, product) {
  if (product.container_type == "keg") {
    return product.container_type;
  } else if (product.container_type == "box" && !product.container_case_size) {
    return product.container_type;
  }

  if (discount.target_container != "units") {
    return "case";
  } else {
    if (product.container_type == "other") {
      return "unit";
    } else {
      return product.container_type;
    }
  }
};
